module.exports = __webpack_public_path__ + "static/img/buzzer3v-1 (2).72f8763.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/buzzer3v-1 (2).svg
// module id = B63g
// module chunks = 0